import { ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const adultAndChildrenEmptyValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  try {
    const adults = control.get('adults').value;
    const children = control.get('numberChildren').value;
    return +adults === 0 && +children === 0 ? {'adultAndChildrenEmpty': true } : null;
  } catch (e) {
    console.error('adultAndChildrenEmptyValidator-error: ' + e.message);
    return {'adultAndChildrenEmpty': true };
  }
};
